
export const AssetHistoryValidation = (formData) => {
    const errors = {};

    if (!formData.dt_Created || !formData.dt_Created.trim()) {
        errors.dt_Created = 'This field is required';
    }

    if (!formData.vc_Description || !formData.vc_Description.trim()) {
        errors.vc_Description = 'This field is required';
    }

    

    return errors;
};
